import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import moment from "moment";
import { toast } from "react-toastify";
import { dateConversion } from "../../../components/Validation";

const SalaryTemplateForm = (props) => {
  const frmRef = useRef({});
  const [activeSalaryHeadList, setActiveSalaryHeadList] = useState([]);
  const [wareHouseData, setWareHouseData] = useState([]);
  const [financialYearData, setFinancialYearData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [employeeData, setEmployeeData] = useState();

  const [employees, setEmployees] = useState([]);

  const [warehouseId, setWarehouseId] = useState(0);
  const [financialYearId, setFinancialYearId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [designationId, setDesignationId] = useState(0);
  const [employeeId, setEmployeeId] = useState(0);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [selectedEffectiveDate, setSelectedEffectiveDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const handleEffectiveDateChange = (e) => {
    setSelectedEffectiveDate(e.target.value);
  };
  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //// //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getfinancialYear } = useHttp();

  const FillFinancialYear = () => {
    getfinancialYear(
      {
        url: `/api/financialYear/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setFinancialYearData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillFinancialYear();
  }, [getfinancialYear]);

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getDepartment } = useHttp();
  const fillDepartment = () => {
    getDepartment(
      {
        url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setDepartmentData(res);
        }
      }
    );
  };

  useEffect(() => {
    fillDepartment();
  }, [getDepartment]);

  const { sendRequest: getDesignation } = useHttp();
  const FillDesignation = () => {
    getDesignation(
      {
        url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setDesignationData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDesignation();
  }, [getDesignation]);

  const { sendRequest: getActiveSalaryHead } = useHttp();

  const FillActiveSalaryHead = () => {
    getActiveSalaryHead(
      {
        url: `/api/getActiveSalaryHead/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setActiveSalaryHeadList(res);
        }
      }
    );
  };

  useEffect(() => {
    FillActiveSalaryHead();
  }, [getActiveSalaryHead]);

  const calculateTemplate = (empData, mainIndex) => {
    var salaryTemplateDetails = empData[mainIndex].salaryTemplateDetails;

    var totalPayout = 0;
    salaryTemplateDetails.forEach((element) => {
      if (element.calculationType == "Add") {
        totalPayout = totalPayout + parseFloat(element.salaryHeadAmount ?? 0);
      } else {
        totalPayout = totalPayout - parseFloat(element.salaryHeadAmount);
      }
    });
    // //console.log(totalPayout);
    empData[mainIndex].inhandSalary = totalPayout;
    setEmployeeData([...empData]);
  };

  const { sendRequest: getemployeeData } = useHttp();
  const FillEmployeeData = (wId) => {
    try {
      getemployeeData(
        {
          url: `/api/employeeForSalaryTemplate/?orgId=${localStorage.getItem(
            "orgId"
          )}&warehouseId=${wId}`,
        },
        (res) => {
          if (res) {
            console.log(res);
            setEmployees(res);

            const updatedEmp = res.map((employee) => ({
              ...employee,
              createdBy: parseInt(localStorage.getItem("id")),
              status: 1,
              orgId: localStorage.getItem("orgId"),
            }));

            setEmployeeData(updatedEmp);
          }
        }
      );
    } catch (error) {
      // //console.log("error", error);
      console.error(error); // You might send an exception to your error tracker like AppSignal
      return error;
    }
  };

  useEffect(() => {
    FillEmployeeData(0);
  }, [getemployeeData]);

  useEffect(() => {
    FillEmployeeData(warehouseId);
  }, [warehouseId]);

  const { sendRequest: postSalaryTemplate } = useHttp();

  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   // //console.log("employeeData", employeeData);

  //   var sdate = moment(frmRef.current.date.value).format("DD/MM/YYYY");
  //   var seffectiveFrom = moment(frmRef.current.effectiveFrom.value).format(
  //     "DD/MM/YYYY"
  //   );
  //   var iCounter = 0;
  //   employeeData.forEach((element) => {
  //     employeeData[iCounter].salaryTemplateDate = sdate;
  //     var oldeffectiveFrom = dateConversion(
  //       employeeData[iCounter].effectiveFrom,
  //       "YYYY-MM-DD",
  //       "DD/MM/YYYY"
  //     );

  //     if (seffectiveFrom != oldeffectiveFrom) {
  //       //  delete employeeData[iCounter]["salaryTemplateId"];
  //       var salaryTemplateDetails =
  //         employeeData[iCounter].salaryTemplateDetails;
  //       var kCounter = 0;
  //       salaryTemplateDetails.forEach((element) => {
  //         delete salaryTemplateDetails[kCounter]["salaryTemplateDetailId"];
  //         delete salaryTemplateDetails[kCounter]["salaryTemplateId"];

  //         kCounter++;
  //       });
  //       // //console.log(salaryTemplateDetails);
  //       employeeData[iCounter].salaryTemplateDetails = salaryTemplateDetails;
  //     }
  //     employeeData[iCounter].salaryTemplateName =
  //       element["employeeName"] +
  //       " " +
  //       element["employeeCode"] +
  //       " " +
  //       seffectiveFrom;
  //     employeeData[iCounter].effectiveFrom = seffectiveFrom;
  //     employeeData[iCounter].orgId = localStorage.getItem("orgId");
  //     employeeData[iCounter].status = 1;
  //     employeeData[iCounter].createdBy = localStorage.getItem("userId");

  //     iCounter++;
  //   });

  //   console.log("employeeData",employeeData);

  //   // postSalaryTemplate(
  //   //   {
  //   //     url: "/api/salaryTemplate/",
  //   //     method: "POST",
  //   //     body: employeeData,
  //   //   },
  //   //   (data) => {
  //   //     // //console.log(data);
  //   //     toast.success("Employee salary remplate added successfully");
  //   //     props.addForm(false);
  //   //   }
  //   // );
  // };

  const submitHandler = (e) => {
    e.preventDefault();
    // //console.log("employeeData", employeeData);

    var sdate = moment(selectedDate).format("DD/MM/YYYY");
    var seffectiveFrom = moment(frmRef.current.effectiveFrom.value).format(
      "DD/MM/YYYY"
    );

    const updatedEmployeeData = employeeData.map((emp, i) => {
      const salaryTemplateDetails = emp.salaryTemplateDetails.map((detail) => {
        delete detail.salaryTemplateDetailId;
        delete detail.salaryTemplateId;
        return detail;
      });

      return {
        ...emp,
        salaryTemplateDate: sdate,
        salaryTemplateDetails,
        salaryTemplateName: `${emp.employeeName} ${emp.employeeCode} ${seffectiveFrom}`,
        effectiveFrom: seffectiveFrom,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
      };
    });

    console.log(updatedEmployeeData);

    postSalaryTemplate(
      {
        url: "/api/salaryTemplate/",
        method: "POST",
        body: updatedEmployeeData,
      },
      (data) => {
        toast.success("Employee salary remplate added successfully");
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                {/* */}
                <div className="card-header">
                  <h3 className="card-title">Salary Template Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"Date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"warehouse"}>{"WareHouse"}</label>
                      <select
                        className="form-control dropdowns"
                        id={"warehouse"}
                        required
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                        }}
                        value={warehouseId}
                      >
                        <option value="0">Select</option>
                        {wareHouseData &&
                          wareHouseData.map((x) => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"FinancialYear"} className="headerlabel">
                        {"Financial Year"}
                      </label>
                      <select
                        className="form-control dropdowns"
                        id={"financialYearId"}
                        value={financialYearId}
                        onChange={(e) => {
                          //setFinancialYearId(e.target.value);
                          console.log(e.target.value);
                          
                        }}
                      >
                        <option value="">Select</option>
                        {financialYearData &&
                          financialYearData.map((x) => (
                            <option
                              key={x.financialYearId}
                              value={x.financialYearId}
                            >
                              {x.financialYearName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"Department"}>{"Department"}</label>
                      <select
                        className="form-control dropdowns"
                        id={"department"}
                        onChange={(e) => {
                          setDepartmentId(e.target.value);
                        }}
                        value={departmentId}
                      >
                        <option value="0">Select</option>
                        {departmentData &&
                          departmentData.map((x) => (
                            <option key={x.departmentId} value={x.departmentId}>
                              {x.departmentName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"Designation"}>{"Designation"}</label>
                      <select
                        className="form-control dropdowns"
                        id={"designation"}
                        onChange={(e) => {
                          setDesignationId(e.target.value);
                        }}
                        value={designationId}
                      >
                        <option value="">Select</option>
                        {designationData &&
                          designationData.map((x) => (
                            <option
                              key={x.designationId}
                              value={x.designationId}
                            >
                              {x.designationName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"Employee"}>{"Employee"}</label>
                      <select
                        className="form-control dropdowns"
                        id={"Employee"}
                        onChange={(e) => {
                          employeeId(e.target.value);
                        }}
                        value={employeeId}
                      >
                        <option value="0">Select</option>
                        {employees &&
                          employees.map((x) => (
                            <option key={x.empId} value={x.empId}>
                              {x.employeeName + "(" + x.employeeCode + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"effectiveFrom"}>
                        {"Effective From"}
                      </label>
                      <input
                        type={"date"}
                        id={"effectiveFrom"}
                        //  required
                        ref={(el) => (frmRef.current["effectiveFrom"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={selectedEffectiveDate}
                        onChange={handleEffectiveDateChange}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <table className="table table-bordered table-sm text-center table-responsive">
                      <tr className="tableheaderrowview">
                        <th>Employee Name</th>
                        <th>Employee Code</th>
                        <th>Gross Salary</th>
                        {activeSalaryHeadList.map((headItem, index) => (
                          <React.Fragment key={index}>
                            <th>{headItem.salaryHeadName}</th>
                          </React.Fragment>
                        ))}
                        <th>Final Payout</th>
                      </tr>

                      <tbody>
                        {employeeData &&
                          employeeData.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td> {itm.employeeName}</td>
                                <td>{itm.employeeCode} </td>

                                <td>
                                  <input
                                    type={"text"}
                                    id={"grossSalary"}
                                    ref={(el) =>
                                      (frmRef.current["grossSalary	"] = el)
                                    }
                                    className="form-control"
                                    value={employeeData[i].grossSalary}
                                    onChange={(e) => {
                                      employeeData[i].grossSalary =
                                        e.target.value;
                                      calculateTemplate(employeeData, i);
                                    }}
                                  />
                                </td>
                                {itm.salaryTemplateDetails.map(
                                  (headItem, index) => (
                                    <React.Fragment key={index}>
                                      <td>
                                        <input
                                          type={"text"}
                                          id={"totalHrs"}
                                          ref={(el) =>
                                            (frmRef.current["totalHrs"] = el)
                                          }
                                          className="form-control"
                                          value={
                                            employeeData[i]
                                              .salaryTemplateDetails[index]
                                              .salaryHeadAmount
                                          }
                                          onChange={(e) => {
                                            employeeData[
                                              i
                                            ].salaryTemplateDetails[
                                              index
                                            ].salaryHeadAmount = e.target.value;
                                            calculateTemplate(employeeData, i);
                                          }}
                                        />
                                      </td>
                                    </React.Fragment>
                                  )
                                )}
                                <td>
                                  <input
                                    type={"text"}
                                    id={"finalPayout"}
                                    defaultValue={itm.inhandSalary}
                                    value={itm.inhandSalary || 0}
                                    ref={(el) =>
                                      (frmRef.current["inhandSalary"] = el)
                                    }
                                    className="form-control"
                                    readOnly
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <br />
                  </div>
                  <div className="text-center">
                    <button className="btn btn-primary" type="submit">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalaryTemplateForm;
